import { render, staticRenderFns } from "./today-clazz-list.vue?vue&type=template&id=470d2657&scoped=true&"
import script from "./today-clazz-list.vue?vue&type=script&lang=js&"
export * from "./today-clazz-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470d2657",
  null
  
)

export default component.exports